import React, { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { ALIGN, InfoBox, useDevice } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { RefundBanner } from "../refundbanner/RefundBanner";

interface OrderBannersProps {
  readonly showExpired: boolean;
  readonly showRefundNotification: boolean;
  readonly style?: StyleProp<ViewStyle>;
}

const OrderBanners: FC<OrderBannersProps> = ({ showExpired, showRefundNotification, style: customStyle }) => {
  const { screen } = useDevice();

  const orderClosedText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_CLOSED,
  });

  return (
    <>
      {showExpired && !showRefundNotification && (
        <InfoBox
          contentAlign={screen.L ? ALIGN.CENTER : undefined}
          icon="returns"
          style={customStyle}
          text={orderClosedText}
        />
      )}
      {showRefundNotification && <RefundBanner style={customStyle} />}
    </>
  );
};

export { OrderBanners };
